const Logo = ({ className }: { className?: string }) => {
    return (
        <div className={`${className}`}>
            <img src="/logo.png" alt="Logo" className="w-32 h-auto" />
        </div>
    );
};

export default Logo;
